import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {ActivatedRoute, Router} from "@angular/router";
import {WebService} from "../services/web/web.service";
import {SpinnerService} from "../services/spinner/spinner.service";
import {ToastService} from "../services/notification/toast.service";
import {ListFailedPaymentFilter} from "./list-failed-payment.filter";
import {TableService} from "./pager";
import {MatTableDataSource} from "@angular/material/table";
import {AppConfirmService} from "../app-confirm/app-confirm.service";
import {SecurityService} from "../services/security.service";
import {UserPermissionsService} from "../services/user-permissions.service";

@Component({
    selector: 'app-list-failed-payment',
    templateUrl: './list-failed-payment.component.html',
    styleUrls: ['./list-failed-payment.component.scss'],
    providers: [AppConfirmService],
    standalone: false
})
export class ListFailedPaymentComponent {

  // Panel de búsqueda
  isOpenSearchPanel = false;
  // Opciones para los dropdowns
  services: any[] = [];
  plansByService: any[] = [];

  selectedServices: any[] = [];
  selectedPlans: any[] = [];

  filter = new ListFailedPaymentFilter(this.tableService.filter);

  // Tabla
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort: MatSort | undefined;
  displayedColumns: string[] = ['service', 'plan', 'firstName', 'lastName', 'code', 'email', 'dateLastInvoice', 'actions'];
  dataSource: any;

    constructor(
        private securityService: SecurityService,
        public tableService: TableService<any>,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private confirmService: AppConfirmService,
        private webService: WebService,
        private spinner: SpinnerService,
        private toast: ToastService,
        private userPermissionsService: UserPermissionsService
    ) {
        this.tableService = new TableService;
    }

  ngOnInit(): void {
    this.isOpenSearchPanel = true;
    this.loadServices();
    this.list();
  }

  list(event?: PageEvent) {
    if (!this.canManageFailedPayments()) {
      this.toast.showWarning("No tienes permisos para consultar cobros fallidos.");
      this.dataSource = [];
      return;
    }

    this.spinner.open();
    this.filter.service = this.selectedServices.join(',');
    this.filter.plan = this.selectedPlans.join(',');
    this.filter.partner = this.securityService.getTokenPartner();

    let httpParams = this.webService.buildRequestParams(this.tableService.sort, "m", {
      pageIndex: event ? event.pageIndex : this.tableService.pager.pageIndex,
      pageSize: event ? event.pageSize : this.tableService.pager.pageSize
    });

    httpParams = this.filter.getHttpParams(httpParams);
    console.log(httpParams);
    this.webService.get(
        this.webService.HOST + "/invoices/failed-payments/report",
        httpParams
    ).subscribe(response => {
      this.spinner.close();
      if (response['result'].length === 0) {
        this.toast.showWarning("No existen resultados para mostrar");
      }

      // Formatear dateLastInvoice a YYYY-mm-dd
      // Formatear dateLastInvoice a YYYY-mm-dd
      const formattedResult = response['result'].map((item: any) => ({
        ...item,
        dateLastInvoice: item.dateLastInvoice
            ? new Date(item.dateLastInvoice).toISOString().slice(0, 10)
            : null
      }));

      console.log(formattedResult);
      this.dataSource = new MatTableDataSource<any>(formattedResult);

      this.tableService.pager = response['pager'];
      this.tableService.selection.clear();
    }, (err) => {
      console.log(err)
      this.spinner.close();
      this.toast.showError(err);
    });

  }

  search() {
    if (!this.canManageFailedPayments()) {
      this.toast.showWarning("No tienes permisos para consultar cobros fallidos.");
      return;
    }

    // Puedes guardar el filtro en el servicio si lo necesitas
    this.tableService.filter =  new ListFailedPaymentFilter(this.filter);
    this.list();
  }

  reset() {

    this.filter = new ListFailedPaymentFilter();
    this.tableService.filter = null;
    this.dataSource = [];
    delete this.filter.firstName;
    delete this.filter.lastName;
    delete this.filter.code;
    delete this.filter.email;
    this.selectedServices = [];
    this.selectedPlans = [];

    this.search();
  }

  openSearchPanel(value: boolean) {
    this.isOpenSearchPanel = value;
    this.filter = new ListFailedPaymentFilter(this.filter);
  }

  goBack() {
    this.router.navigate(["/my-portals"]);
  }

  reactivate(invoice: any) {
    if (!this.canManageFailedPayments()) {
      this.toast.showWarning("No tienes permisos para reactivar cobros fallidos.");
      return;
    }

    this.spinner.open();
    this.webService.put({}, this.webService.HOST + "/invoices/" + invoice.id +"/update/status/26").subscribe( response => {
      this.toast.showSuccess("Factura reactivada correctamente");
      this.ngOnInit();
    }, error => {
      this.spinner.close();
      this.toast.showError(error.message);
    });

  }

  onPlanSelectionChange(selectedPlans: any[]): void {
    if (selectedPlans.includes('selectAll')) {
      if (this.selectedPlans.length - 1  === this.plansByService.length) {
        // Si todos los servicios ya están seleccionados, deselecciona todos
        this.selectedPlans = [];
      } else {
        // Si no todos los servicios están seleccionados, selecciona todos
        this.selectedPlans = this.plansByService.map(plan => plan.id);
      }
    } else {
      this.selectedPlans = selectedPlans;
    }

    this.selectedPlans.sort((a: any, b: any) => {
      if (a.name_plan < b.name_plan) {
        return -1;
      }
      if (a.name_plan > b.name_plan) {
        return 1;
      }
      return 0;
    });

    }


  onServiceSelectionChange(selectedServices: any[]): void {
    if (selectedServices.includes('selectAll')) {
      if (this.selectedServices.length - 1  === this.services.length) {
        // Si todos los servicios ya están seleccionados, deselecciona todos
        this.selectedServices = [];
      } else {
        // Si no todos los servicios están seleccionados, selecciona todos
        this.selectedServices = this.services.map(service => service.id);
      }
    } else {
      this.selectedServices = selectedServices;
    }

    this.selectedServices.sort((a: any, b: any) => {
      if (a.name_service < b.name_service) {
        return -1;
      }
      if (a.name_service > b.name_service) {
        return 1;
      }
      return 0;
    });

    this.loadPlansForSelectedServices();
  }

  loadPlansForSelectedServices(): void {
    if (this.selectedServices.length === 0) {
      this.plansByService = [];
      return;
    }

    this.spinner.open();
    // const params = new HttpParams().set('list', this.selectedServices.join(','));
    this.webService.get(`${this.webService.HOST}/partner/services/plan?list=` + this.selectedServices.join(','))
        .subscribe(
            (response: any) => {
              this.plansByService = response.result;
              this.spinner.close();
              // Sort services alphabetically by name_service
              this.plansByService.sort((a: any, b: any) => {
                if (a.name_plan < b.name_plan) {
                  return -1;
                }
                if (a.name_plan > b.name_plan) {
                  return 1;
                }
                return 0;
              });
            },
            (error) => {
              this.spinner.close();
              this.toast.showError(error);
            }
        );
  }

  loadServices(): void {
    this.spinner.open();
    const partnerId = this.securityService.getTokenPartner();
    if (!partnerId) {
      this.spinner.close();
      return this.toast.showInfo("No se puede cargar servicios porque no se encontró un partner.");
    }

    this.webService.get(`${this.webService.HOST}/partner/${partnerId}/services`)
        .subscribe(
            (response: any) => {
              this.services = response.result;
              // Sort services alphabetically by name_service
              this.services.sort((a: any, b: any) => {
                if (a.name_service < b.name_service) {
                  return -1;
                }
                if (a.name_service > b.name_service) {
                  return 1;
                }
                return 0;
              });
              this.spinner.close();
            },
            (error) => {
              this.spinner.close();
              this.toast.showError(error);
            }
        );
  }
  reactivateItem(row : any) {
    if (!this.canManageFailedPayments()) {
      this.toast.showWarning("No tienes permisos para reactivar cobros fallidos.");
      return;
    }

    this.confirmService.confirm({title: 'Confirmación', message: "¿Confirma que desea reactivar el cobro? Esta acción reiniciará el proceso de facturación."})
        .subscribe(res => {
          if (res) {
            this.reactivate(row);
          }
        })
  }

  canManageFailedPayments(): boolean {
    return this.userPermissionsService.hasPermission("controllers.Invoices.findReportFailedPayments");
  }


}
